/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Suggestion_ReviewInputs */

const en_us2_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the new plan`)
};

const pt_br2_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar o novo plano`)
};

const es_419_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar el nuevo plan`)
};

const pt_pt2_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever o novo plano`)
};

const fr_fr2_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examiner le nouveau programme`)
};

const de_de2_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Plan prüfen`)
};

const it_it2_plan_suggestion_review = /** @type {(inputs: Plan_Suggestion_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi la nuova scheda`)
};

/**
* | output |
* | --- |
* | "Review the new plan" |
*
* @param {Plan_Suggestion_ReviewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_suggestion_review = /** @type {((inputs?: Plan_Suggestion_ReviewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Suggestion_ReviewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_suggestion_review(inputs)
	if (locale === "es-419") return es_419_plan_suggestion_review(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_suggestion_review(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_suggestion_review(inputs)
	if (locale === "de-DE") return de_de2_plan_suggestion_review(inputs)
	if (locale === "it-IT") return it_it2_plan_suggestion_review(inputs)
	return en_us2_plan_suggestion_review(inputs)
});
export { plan_suggestion_review as "plan.suggestion.review" }